import * as API from "middleware/api";
import * as restAPI from "middleware/apiRESTful";
import { format } from "date-fns";
import * as configUtils from "util/config";

export const downloadStatement = (idDeposit, idStatementLine) =>
    API.executeWithAccessToken("/deposits.downloadStatementLine", { idDeposit, idStatementLine });

export const editMovementNote = (idProduct, idStatement, note) =>
    API.executeWithAccessToken("/notes.editStatementNote", { idProduct, idStatement, note });

export const listDeposits = () => API.executeWithAccessToken("/deposits.list");

export const listMovements = (idDeposit, filters) => {
    let { dateFrom, dateTo } = filters;
    const { channels, check, minAmount, maxAmount, pageNumber, reference, fullList } = filters;

    dateFrom = dateFrom ? format(dateFrom, "YYYY-MM-DD") : null;
    dateTo = dateTo ? format(dateTo, "YYYY-MM-DD") : null;

    if (configUtils.getBoolean("ms.deposit.enabled", false)) {
        return restAPI.getWithAccessToken(`/api/deposits/v1/deposits/${idDeposit}/statements`, {
            channels,
            check,
            dateFrom,
            dateTo,
            minAmount,
            maxAmount,
            pageNumber,
            reference,
            fullList,
        });
    }

    return API.executeWithAccessToken("/deposits.listStatements", {
        idDeposit,
        channels,
        check,
        dateFrom,
        dateTo,
        minAmount,
        maxAmount,
        pageNumber,
        reference,
        fullList,
    });
};

export const listStatements = (idDeposit) =>
    API.executeWithAccessToken("/deposits.listStatementLines", {
        idDeposit,
    });

export const movementDetails = (idDeposit, idStatement) =>
    API.executeWithAccessToken("/deposits.listStatementDetails", {
        idDeposit,
        idStatement,
    });

export const readDeposit = (idDeposit) => {
    if (configUtils.getBoolean("ms.deposit.enabled", false)) {
        return restAPI.getWithAccessToken(`/api/deposits/v1/deposits/${idDeposit}`);
    }
    return API.executeWithAccessToken("/deposits.read", { idDeposit });
};

export const downloadMovements = (idDeposit, { dateFrom = null, dateTo = null, ...filters }, fileFormat) =>
    API.executeWithAccessToken("/deposits.downloadMovements", {
        idDeposit,
        format: fileFormat,
        dateFrom: dateFrom && format(dateFrom, "YYYY-MM-DD"),
        dateTo: dateTo && format(dateTo, "YYYY-MM-DD"),
        ...filters,
    });

export const downloadCertified = (data) => API.executeWithAccessToken("/deposits.onBase.download", { data });
export const downloadCertifiedByProductId = (productId) =>
    API.executeWithAccessToken("/deposits.onBase.download", { productId });
